import $ from 'jquery'
import { delay, kebabCase } from 'lodash'
import { createLeadAssistant } from '@quero/qb-partials/src/javascripts/components/lead_assistant'
import ScreenUtils from 'application/screen_utils'
import { initMultipleSlider } from 'application/shared/sliders'
import Tooltip from 'tooltip.js'

slugify = (value) ->
  if !value
    value
  else
    kebabCase value.replace(/[']/g, '-').toLowerCase()

_require ['bootstrap/popover'], ->
  newPopoverTemplate = $($.fn.popover.Constructor.DEFAULTS.template).removeClass('grey-popover')

tooltips = $('.js-university-ratings-tooltip')
template_tooltip = '<div class="tooltip university_ratings__tooltip" role="tooltip"><div class="tooltip-inner"></div></div>'
for tooltip in tooltips
  new Tooltip(tooltip, {
    placement: 'bottom',
    title: tooltip.getAttribute('data-title'),
    container: 'body',
    template: template_tooltip
  })

_require [
 'jquery/perfect-scrollbar'
], ->
  $('.js-student-evaluation-box__content-wrapper').perfectScrollbar()

_require ['university_ratings'], ->
  initMultipleSlider()

  $('.js-modal-submit').on 'click', (e)->
    delay(->
      $('#js-lead-modal').modal('hide')
    , 1000)

  _require ['swiper'], ->
    swiper = null
    swiperOn = off

    loadCourseCardSwiper = ->
      swiper = new Swiper('.js-best-offers-swiper',
        spaceBetween: 30
        slidesPerView: 3
        slidesPerGroup: 3
        simulateTouch: false
        freeMode: true
        freeModeSticky: true
        pagination:
          el: '.swiper-pagination'
          clickable: true
        breakpoints:
          992:
            spaceBetween: 0
            slidesPerView: 'auto'
            slidesPerGroup: 1
      )
      swiperOn = on

    $(window).resize ->
      if ScreenUtils.smOrSmaller()
        if not swiperOn
          loadCourseCardSwiper()
      else
        if swiper? && swiperOn
          swiper.destroy(yes, yes)
          swiperOn = off

    $(window).resize()

  new QB.UniversityRatingsBehaviour('all')


  $(document).on 'facebook.rendered', ->
    $.each $('.associated .avatar'), (index, el)->
      user_photo    = $(el).find('.facebook-avatar')
      user_initials = $(el).find('.user-initials')
      data = user_photo.data()
      FB.api "/#{data.uid}/picture", 'GET', { "fields": "is_silhouette" }, (response)->
        if response.data?.is_silhouette
          user_photo.remove()
          user_initials.removeClass('hide')

  _require ['canonical_selector'], ->
    canonicalSelect = new QB.CanonicalSelector
    canonicalSelect.init('#interest_course_in_modal')
    canonicalSelect.init('#interest_course_in_header', 'courses-canonical-id')
    canonicalSelect.init('#interest_course')

$('.js-lead-form.university-widget__form').on 'ajax:success', ->
  $('#js-search-modal').modal("show")

createLeadAssistant()

$('.js-university-widget-form').on('submit', (evt) ->
  evt.preventDefault()
  form = evt.currentTarget
  $form = $(form)
  formData = {}

  $form.serializeArray().forEach((entry) ->
    formData[entry.name] = entry.value
  )

  query = {}

  if (formData['canonical_course_id'])
    query.c = $('.select2-chosen', $form).text()

  lc = (formData['interest[city]'] || '').replace(/\-.*$/, '').trim()
  ls = formData['interest[state]']

  if (lc && ls)
    query.lc = slugify(lc)
    query.ls = slugify(ls)

  if (Object.keys(query).length > 0)
    queryString = _(query).map((value, key) ->
      "#{key}=#{encodeURIComponent(value)}"
    ).join('&')

    document.location.href = "#{form.action}?#{queryString}"
  else
    document.location.href = form.action
)
